import { render } from "./MessageLoading.vue?vue&type=template&id=f41e4138&scoped=true"
import script from "./MessageLoading.vue?vue&type=script&lang=js"
export * from "./MessageLoading.vue?vue&type=script&lang=js"

import "./MessageLoading.vue?vue&type=style&index=0&id=f41e4138&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41e4138"]])

export default __exports__